'use client';

import { useOwner } from '@/app/contact/context/OwnerProvider';
import { Reviews } from '@/components/shared/Reviews';
import { Button } from '@/components/ui/Button';
import { ModalTrigger } from '@/components/ui/ModalTrigger';
import { useAnalytics } from '@/hooks/useAnalytics';
import dynamic from 'next/dynamic';

// Lazy load the modal component
const AllOwnerReviewsModal = dynamic(() =>
  import('./modals/AllOwnerReviewsModal').then(mod => mod.AllOwnerReviewsModal),
);

export function OwnerReviews() {
  const { ownerReviews, isMasked } = useOwner();
  const { count: reviewCount } = ownerReviews;
  const analytics = useAnalytics();

  return (
    <Reviews
      reviews={ownerReviews}
      isMasked={isMasked}
      showAddress={true}
      eventScreen="contact"
      onViewAll={
        <ModalTrigger label="Reviews" content={<AllOwnerReviewsModal />} urlKey="reviews">
          <Button
            className="md:self-start w-full md:w-auto"
            variant="secondary"
            size="sm"
            disabled={isMasked}
            onClick={() => {
              analytics.track('contact_view_more_reviews');
            }}
          >
            View all {reviewCount} reviews
          </Button>
        </ModalTrigger>
      }
    />
  );
}
